import { get } from './api';

// 获取渠道信息，其中有一个price是渠道优惠价
const getChannel = get('channel/get-public-info-by-code');

// 获取当前账号的渠道
const getMineChannel = get('channel/mine');

// 获取当前账号下的子渠道
const getSubChannel = get('channel/sub-channels');

export {
  getChannel,
  getMineChannel,
  getSubChannel
}
